module.exports = __webpack_public_path__ + "static/media/cloud_infrastructure.d4398470.svg";